var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 11.96 18.542 8.157V45L5.06 38.313A3.3 3.3 0 0 1 3 35.255zm43-.953-.315 22.6a3.3 3.3 0 0 1-2.08 3.02L22.65 44.968V20.1zM28.074 2.3l17.07 7.868-23.056 8.988L3.852 11.13l21.584-8.885a3.3 3.3 0 0 1 2.638.054",
    className: "Orders_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.62 5 15.957 7.84L37 14.586l-2.845 1.109 2.323-.903v6.879L30.682 24v-6.954l.021-.009-1.616-1.654L13 7.69z",
    className: "Orders_svg__flowIconSnowStorm"
  }))));
};
export default SvgOrders;